import { currentBreakpoint, currentOrientation, viewport } from "../../exports/viewport";
import { defineStore } from "../../common/nexus";
import { setDevSpecsCookie } from "./tracking/devSpecCookie";
import {
  breakpointChangeListener,
  orientationChangeListener,
  updtateTrackingViewportData,
} from "./tracking/trackingHandler";
import {
  initializeBreakpointHandler,
  getCurrentBreakpoint,
  isActiveBreakpoint,
  withBreakpoints,
} from "./breakpoint/breakpoint";
import {
  initializeOrientationHandler,
  getCurrentOrientation,
  isActiveOrientation,
  withOrientations,
} from "./orientation/orientation";
import type { Breakpoint } from "./breakpoint/types";
import type { Orientation } from "./orientation/types";
import { getScrollbarWidth } from "./scrollbar/scrollbar";

viewport.assignNamespace({
  /*         */
  currentBreakpoint: defineStore<Breakpoint | undefined>(getCurrentBreakpoint() as Breakpoint),
  getCurrentBreakpoint,
  isActiveBreakpoint,
  withBreakpoints,

  /*          */
  currentOrientation: defineStore<Orientation | undefined>(getCurrentOrientation() as Orientation),
  getCurrentOrientation,
  isActiveOrientation,
  withOrientations,

  getScrollbarWidth,

  /*                                  */
  /*                                                          */
  __breakpoints: { $: defineStore<any>() },
  /*                                                          */
  __orientations: { $: defineStore<any>() },
});

/*                                                */
initializeBreakpointHandler();
initializeOrientationHandler();

/*                                 */
currentBreakpoint.sub(setDevSpecsCookie);

/*                                                */
/*                                             */
updtateTrackingViewportData();
/*                                                        */
currentBreakpoint.sub(breakpointChangeListener, { skipRetained: true });
currentOrientation.sub(orientationChangeListener, { skipRetained: true });
